import { useEffect, useState, useContext } from "react";
import { MyContext } from "../../../MyContext";
import API from "../../Api";
import { useSession } from "../../session/Context";
import { toast } from "react-toastify";

import React from "react";
import MenuItem from "@mui/material/MenuItem";
import Select, { SelectChangeEvent } from "@mui/material/Select";

import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Box, Tab } from "@mui/material";
import { TabContext, TabPanel, TabList } from "@mui/lab";

import Table from "./Table";

export default function AddIssuance() {
  const { brand, is_admin } = useSession();

  const [templates, setTemplates] = useState<any[]>([]);
  const [selectedTemplate, setSelectedTemplate] = useState("");

  const [issuance, setIssuance] = useState<any>({
    id: "",
    scope: false,
    details: false,
  });

  const { setOnPage } = useContext(MyContext)!;
  useEffect(() => {
    setOnPage(window.location.pathname.substring(1));
  }, []);

  useEffect(() => {
    API("/api/v1/schemas?type=list-schema-factories")
      .then(async (response) => {
        setTemplates(
          Object.keys(response).map((val) => {
            return {
              value: val,
              label: response[val],
            };
          })
        );
      })
      .catch((err) => {
        console.error(err);
      });
  }, [brand, is_admin]);

  const setIssuances = (name: string, value: any) => {
    if (name === "details") {
      value = value === "false";
    }
    setIssuance({ ...issuance, [name]: value });
  };

  const [scopes, setScopes] = useState<any>();
  // Get credential types
  useEffect(() => {
    getScopes();
  }, []);

  function getScopes() {
    API(
      "/api/v1/brand" + (brand == "" ? "/root" : "/" + brand) + "/factory"
    ).then((response) => {
      setScopes(response.scope);
    });
  }

  useEffect(() => {
    // Subtract the scopes from templates
    if (scopes) {
      let existingTemplates = Object.keys(scopes).map((val) => {
        return scopes[val].metadata.display.name;
      });

      let temp = templates.filter((val) => {
        return !existingTemplates.includes(val.label);
      });
      setTemplates(temp);
    }
  }, [scopes]);

  const theme = createTheme({
    palette: {
      secondary: {
        main: "#FF297F",
      },
      primary: {
        main: "#231f20",
      },
    },
    typography: {
      fontFamily: "Saira",
    },
  });

  const tabPanelStyle = {
    padding: "0px",
    marginBottom: "20px",
  };

  interface ManagerData {
    notifData: any;
  }

  const onSubmit = (event: React.FormEvent<HTMLFormElement>): void => {
    event.preventDefault();
    let url = "/api/v1";
    if (brand !== "") {
      url += "/brand/" + brand + "/factory";
    } else {
      url += "/brand/root/factory";
    }

    API(url, {
      method: "POST",
      body: JSON.stringify({ ...issuance, id: issuance.id.value }),
    })
      .then((resp) => {
        toast.success("Successfully Added New Credential Template", {
          theme: "colored",
        });
      })
      .then(() => {
        setSelectedTemplate("");
        getScopes();
      })
      .catch((e) => {
        toast.error("Error " + e, { theme: "colored" });
        console.error(e);
      });
  };

  const handleChangeTemplate = (event: SelectChangeEvent) => {
    setSelectedTemplate(event.target.value);
    setIssuance({
      ...issuance,
      id: templates.find((val) => event.target.value === val.value),
    });
  };

  return (
    <>
      <div className="mobile-pro">
        <div className="login">
          <img src="img/issue-icon-default.svg" />
          <h2>Add credential template</h2>
        </div>
      </div>
      <div className="col-content">
        <div className="notifications-container">
          <div className="issue-credentials">
            <form onSubmit={onSubmit} className="form">
              <div className="add_issuance__cards">
                <div className="cards">
                  <div>
                    <label>Credential Template</label>
                    <Select
                      defaultValue=""
                      required
                      className="template-field"
                      value={selectedTemplate}
                      onChange={handleChangeTemplate}
                      displayEmpty
                      renderValue={(value) => {
                        if (value == "") {
                          return (
                            <em style={{ color: "#8e8e8e", fontSize: "15px" }}>
                              Select Credential Template
                            </em>
                          );
                        } else {
                          return (
                            <em style={{ fontSize: "15px" }}>
                              {issuance.id.label}
                            </em>
                          );
                        }
                      }}
                    >
                      {templates ? (
                        templates.map((item) => {
                          return (
                            <MenuItem
                              /* selected={templates[0].value === item.value} */
                              key={item.value}
                              value={item.value}
                            >
                              {item.label}
                            </MenuItem>
                          );
                        })
                      ) : (
                        <></>
                      )}
                    </Select>
                  </div>
                </div>
              </div>
              <input
                className="form-submit-btn btn btn-primary issuance__btn"
                type="submit"
                value="Add Template"
              ></input>
            </form>
          </div>
          <ThemeProvider theme={theme}>
            <Box sx={{ width: "100%", typography: "body1" }}>
              <TabContext value={"1"}>
                <Box>
                  <TabList
                    value="1"
                    sx={{
                      "& .MuiTab-root": {
                        cursor: "auto",
                      },
                      "& .MuiTab-root.Mui-selected": {
                        color: "#231f20",
                      },
                      "& .MuiTab-textColorSecondary": {
                        color: "#CECECE",
                      },
                    }}
                    textColor="secondary"
                    indicatorColor="secondary"
                    aria-label="secondary tabs example"
                  >
                    <Tab label={"Existing templates"} value="1" />
                  </TabList>
                </Box>

                <TabPanel sx={tabPanelStyle} value="1">
                  <Table data={scopes} />
                </TabPanel>
              </TabContext>
            </Box>
          </ThemeProvider>
        </div>
      </div>
    </>
  );
}
